export default [
  {
    path: '/estudante/pesquisa-geral',
    name: 'Pesquisa Geral Estudante',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/estudante/Estudante-pesquisa-geral.vue'),
  },  
]
